const StringHelper = {
  isEmpty: text => {
    return !StringHelper.isNotEmpty(text);
  },

  isNotEmpty: text => {
    return (
      typeof text !== 'undefined' &&
      text !== undefined &&
      text !== null &&
      text.toString().trim() !== ''
    );
  },

  justNumbers: text => {
    return text.replace(/([^\d]+)/gi, '');
  },

  hexToRgb: hex => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    return result
      ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
      : null;
  },

  stripHtml: text => {
    return text.replace(/(<([^>]+)>)/gi, "");
  },

  htmlToText: text => {
    return text
      .replace(/<\/p>/gi, '\n')
      .replace(/<p[^>]*>/gi, '')
      .replace(/<li[^>]*>/gi, '• ')
      .replace(/<\/li>/gi, '\n')
      .replace(/<ul[^>]*>|<\/ul>|<ol[^>]*>|<\/ol>/gi, '')
      .replace(/<br\s*\/?>/gi, '\n')
      .replace(/(<([^>]+)>)/gi, '')
      .replace(/&nbsp;/gi, ' ')
      .replace(/\r\n|\r/g, '\n')
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  }
};

export default StringHelper;
